import { FaTimes } from "react-icons/fa";

const TaxDetailsModal = ({ isOpen, onClose, taxes, formatCurrency }) => {
    if (!isOpen) return null;
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white rounded-lg p-6 max-w-lg w-full">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-semibold text-secondary">Tax Details</h2>
            <button onClick={onClose} className="text-gray-500 hover:text-gray-700"><FaTimes size={20} /></button>
          </div>
          <div className="divide-y">
            {taxes?.map((tax, index) => (
              <div key={index} className="py-3">
                <div className="flex justify-between">
                  <p className="font-medium">{tax.taxName}</p>
                  <p>{tax.taxPercentage}%</p>
                </div>
                <p className="text-sm text-gray-600">Tax Amount: ${formatCurrency(tax.taxAmount)}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };
  export default TaxDetailsModal